import React from 'react';

export default React.createClass({
	displayName: 'Dummy',
	render() {
		return (
			<div>
			</div>
		);
	}
});


/** WEBPACK FOOTER **
 ** ./src/components/Dummy.js
 **/